export default [
  { city: "Pacific Midway", timezone: "Pacific/Midway", utc_offset: -39600 },
  { city: "Hawaii", timezone: "US/Hawaii", utc_offset: -36000 },
  { city: "Alaska", timezone: "US/Alaska", utc_offset: -32400 },
  { city: "Canada Pacific", timezone: "Canada/Pacific", utc_offset: -28800 },
  { city: "US Pacific", timezone: "US/Pacific", utc_offset: -28800 },
  { city: "Tijuana", timezone: "America/Tijuana", utc_offset: -28800 },
  { city: "Arizona", timezone: "US/Arizona", utc_offset: -25200 },
  { city: "Chihuahua", timezone: "America/Chihuahua", utc_offset: -25200 },
  { city: "Canada Mountain", timezone: "Canada/Mountain", utc_offset: -25200 },
  { city: "US Mountain", timezone: "US/Mountain", utc_offset: -25200 },
  { city: "Central Canada", timezone: "Canada/Central", utc_offset: -21600 },
  { city: "Central US", timezone: "US/Central", utc_offset: -21600 },
  { city: "Guatemala", timezone: "America/Guatemala", utc_offset: -21600 },
  { city: "Mexico City", timezone: "America/Mexico_City", utc_offset: -21600 },
  { city: "Bogota", timezone: "America/Bogota", utc_offset: -18000 },
  { city: "East-Indiana", timezone: "US/East-Indiana", utc_offset: -18000 },
  { city: "Eastern Canada", timezone: "Canada/Eastern", utc_offset: -18000 },
  { city: "Eastern US", timezone: "US/Eastern", utc_offset: -18000 },
  { city: "Canada Atlantic", timezone: "Canada/Atlantic", utc_offset: -14400 },
  { city: "Caracas", timezone: "America/Caracas", utc_offset: -14400 },
  { city: "Manaus", timezone: "America/Manaus", utc_offset: -14400 },
  { city: "New York", timezone: "America/New_York", utc_offset: -14400 },
  { city: "Santiago", timezone: "America/Santiago", utc_offset: -14400 },
  { city: "Newfoundland", timezone: "Canada/Newfoundland", utc_offset: -12600 },
  {
    city: "Buenos Aires",
    timezone: "America/Buenos_Aires",
    utc_offset: -10800,
  },
  { city: "Eastern Brazil", timezone: "Brazil/East", utc_offset: -10800 },
  { city: "Godthab", timezone: "America/Godthab", utc_offset: -10800 },
  { city: "Montevideo", timezone: "America/Montevideo", utc_offset: -10800 },
  { city: "Sao Paulo", timezone: "America/Sao_Paulo", utc_offset: -10800 },
  {
    city: "South Georgia",
    timezone: "Atlantic/South_Georgia",
    utc_offset: -7200,
  },
  { city: "Azores", timezone: "Atlantic/Azores", utc_offset: -3600 },
  { city: "Cape Verde", timezone: "Atlantic/Cape_Verde", utc_offset: -3600 },
  { city: "Belfast", timezone: "Europe/Belfast", utc_offset: 0 },
  { city: "Casablanca", timezone: "Africa/Casablanca", utc_offset: 0 },
  { city: "Dublin", timezone: "Europe/Dublin", utc_offset: 0 },
  { city: "Lisbon", timezone: "Europe/Lisbon", utc_offset: 0 },
  { city: "London", timezone: "Europe/London", utc_offset: 0 },
  { city: "Algiers", timezone: "Africa/Algiers", utc_offset: 3600 },
  { city: "Amsterdam", timezone: "Europe/Amsterdam", utc_offset: 3600 },
  { city: "Andorra", timezone: "Europe/Andorra", utc_offset: 3600 },
  { city: "Belgrade", timezone: "Europe/Belgrade", utc_offset: 3600 },
  { city: "Berlin", timezone: "Europe/Berlin", utc_offset: 3600 },
  { city: "Brussels", timezone: "Europe/Brussels", utc_offset: 3600 },
  { city: "Budapest", timezone: "Europe/Budapest", utc_offset: 3600 },
  { city: "Lagos", timezone: "Africa/Lagos", utc_offset: 3600 },
  { city: "Luxembourg", timezone: "Europe/Luxembourg", utc_offset: 3600 },
  { city: "Madrid", timezone: "Europe/Madrid", utc_offset: 3600 },
  { city: "Monaco", timezone: "Europe/Monaco", utc_offset: 3600 },
  { city: "Oslo", timezone: "Europe/Oslo", utc_offset: 3600 },
  { city: "Paris", timezone: "Europe/Paris", utc_offset: 3600 },
  { city: "Rome", timezone: "Europe/Rome", utc_offset: 3600 },
  { city: "Stockholm", timezone: "Europe/Stockholm", utc_offset: 3600 },
  { city: "Vienna", timezone: "Europe/Vienna", utc_offset: 3600 },
  { city: "Warsaw", timezone: "Europe/Warsaw", utc_offset: 3600 },
  { city: "Zurich", timezone: "Europe/Zurich", utc_offset: 3600 },
  { city: "Amman", timezone: "Asia/Amman", utc_offset: 7200 },
  { city: "Athens", timezone: "Europe/Athens", utc_offset: 7200 },
  { city: "Beirut", timezone: "Asia/Beirut", utc_offset: 7200 },
  { city: "Cairo", timezone: "Africa/Cairo", utc_offset: 7200 },
  { city: "Harare", timezone: "Africa/Harare", utc_offset: 7200 },
  { city: "Helsinki", timezone: "Europe/Helsinki", utc_offset: 7200 },
  { city: "Jerusalem", timezone: "Asia/Jerusalem", utc_offset: 7200 },
  { city: "Johannesburg", timezone: "Africa/Johannesburg", utc_offset: 7200 },
  { city: "Kiev", timezone: "Europe/Kiev", utc_offset: 7200 },
  { city: "Windhoek", timezone: "Africa/Windhoek", utc_offset: 7200 },
  { city: "Baghdad", timezone: "Asia/Baghdad", utc_offset: 10800 },
  { city: "Istanbul", timezone: "Asia/Istanbul", utc_offset: 10800 },
  { city: "Kuwait", timezone: "Asia/Kuwait", utc_offset: 10800 },
  { city: "Minsk", timezone: "Europe/Minsk", utc_offset: 10800 },
  { city: "Moscow", timezone: "Europe/Moscow", utc_offset: 10800 },
  { city: "Nairobi", timezone: "Africa/Nairobi", utc_offset: 10800 },
  { city: "Qatar", timezone: "Asia/Qatar", utc_offset: 10800 },
  { city: "Tehran", timezone: "Asia/Tehran", utc_offset: 12600 },
  { city: "Baku", timezone: "Asia/Baku", utc_offset: 14400 },
  { city: "Dubai", timezone: "Asia/Dubai", utc_offset: 14400 },
  { city: "Muscat", timezone: "Asia/Muscat", utc_offset: 14400 },
  { city: "Tbilisi", timezone: "Asia/Tbilisi", utc_offset: 14400 },
  { city: "Yerevan", timezone: "Asia/Yerevan", utc_offset: 14400 },
  { city: "Kabul", timezone: "Asia/Kabul", utc_offset: 16200 },
  { city: "Karachi", timezone: "Asia/Karachi", utc_offset: 18000 },
  { city: "Yekaterinburg", timezone: "Asia/Yekaterinburg", utc_offset: 18000 },
  { city: "Calcutta", timezone: "Asia/Calcutta", utc_offset: 19800 },
  { city: "Colombo", timezone: "Asia/Colombo", utc_offset: 19800 },
  { city: "Kathmandu", timezone: "Asia/Kathmandu", utc_offset: 20700 },
  { city: "Dhaka", timezone: "Asia/Dhaka", utc_offset: 21600 },
  { city: "Rangoon", timezone: "Asia/Rangoon", utc_offset: 23400 },
  { city: "Bangkok", timezone: "Asia/Bangkok", utc_offset: 25200 },
  { city: "Ho Chi Minh", timezone: "Asia/Ho_Chi_Minh", utc_offset: 25200 },
  { city: "Jakarta", timezone: "Asia/Jakarta", utc_offset: 25200 },
  { city: "Krasnoyarsk", timezone: "Asia/Krasnoyarsk", utc_offset: 25200 },
  { city: "Novosibirsk", timezone: "Asia/Novosibirsk", utc_offset: 25200 },
  { city: "Hong Kong", timezone: "Asia/Hong_Kong", utc_offset: 28800 },
  { city: "Irkutsk", timezone: "Asia/Irkutsk", utc_offset: 28800 },
  { city: "Kuala Lumpur", timezone: "Asia/Kuala_Lumpur", utc_offset: 28800 },
  { city: "Perth", timezone: "Australia/Perth", utc_offset: 28800 },
  { city: "Shanghai", timezone: "Asia/Shanghai", utc_offset: 28800 },
  { city: "Singapore", timezone: "Asia/Singapore", utc_offset: 28800 },
  { city: "Taipei", timezone: "Asia/Taipei", utc_offset: 28800 },
  { city: "Seoul", timezone: "Asia/Seoul", utc_offset: 32400 },
  { city: "Tokyo", timezone: "Asia/Tokyo", utc_offset: 32400 },
  { city: "Yakutsk", timezone: "Asia/Yakutsk", utc_offset: 32400 },
  { city: "Adelaide", timezone: "Australia/Adelaide", utc_offset: 34200 },
  { city: "Darwin", timezone: "Australia/Darwin", utc_offset: 34200 },
  { city: "Brisbane", timezone: "Australia/Brisbane", utc_offset: 36000 },
  { city: "Canberra", timezone: "Australia/Canberra", utc_offset: 36000 },
  { city: "Guam", timezone: "Pacific/Guam", utc_offset: 36000 },
  { city: "Hobart", timezone: "Australia/Hobart", utc_offset: 36000 },
  { city: "Melbourne", timezone: "Australia/Melbourne", utc_offset: 36000 },
  { city: "NSW", timezone: "Australia/NSW", utc_offset: 36000 },
  { city: "Queensland", timezone: "Australia/Queensland", utc_offset: 36000 },
  { city: "Sydney", timezone: "Australia/Sydney", utc_offset: 36000 },
  { city: "Vladivostok", timezone: "Asia/Vladivostok", utc_offset: 36000 },
  { city: "Magadan", timezone: "Asia/Magadan", utc_offset: 39600 },
  { city: "Auckland", timezone: "Pacific/Auckland", utc_offset: 43200 },
  { city: "Fiji", timezone: "Pacific/Fiji", utc_offset: 43200 },
  { city: "Tongatapu", timezone: "Pacific/Tongatapu", utc_offset: 46800 },
];
